module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/tr-card-drag.348ff1a2b8a6fc8923c8.gif";